import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const http = axios.create({
    baseURL: API,
    withCredentials: true,
});

http.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err?.response?.status === 401 && typeof window !== "undefined") {
            const path = window.location.pathname;
            if (path !== "/login" && !window.location.hash.includes("session_id=")) {
                window.location.replace("/login");
            }
        }
        return Promise.reject(err);
    },
);
